'use strict';

var angularModule = angular.module('t2g.common.data-access.statistic', []);

module.exports = angularModule;

angularModule.factory('StatisticResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/statistic/:kpi';

  var resource = $resource(resourceUrl, {}, {});

  return resource;
});

angularModule.factory('StatisticDA', function(StatisticResource) {
  return {
    getSales: function(start, end, resolution) {
      return StatisticResource.get({ kpi: 'sales', start: start, end: end, resolution: resolution })
        .$promise;
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/statistic.js